import {Exclude, Expose} from "class-transformer";
import {AbstractApiModel} from "./abstract.api.model";

@Exclude()
export class DeviceTokenApiModel extends AbstractApiModel {
  @Expose() public readonly id: string;
  @Expose() public readonly isEnabled: boolean;
  @Expose() public readonly lastSeenAt: Date;
}
